import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

import { BackToResults, BackToResultsCanvas } from "./component"

export default {
  id: "back-to-results",
  block: {
    category: "Basic",
    icon: <FontAwesomeIcon size="3x" icon={faArrowLeft} />,
    label: "Back to results",
  },
  props: [],
  component: BackToResults,
  canvas: BackToResultsCanvas,
  components: [],
  styles: {
    position: "relative",
  },
}
